import HardwareSerializer from 'eflex/serializers/hardware';

export default class LightGuideSerializer extends HardwareSerializer {}
